import { useEffect, useState } from "react";
import AccueilView from "../Vue/Pages/AccueilView";
import ArticleModel from "../Model/ArticleModel";
import BlogService from "../Service/BlogService";
import TrainingService from "../Service/TrainingService";
import Header from "../Vue/Components/Header";

const GetAccueilController = () => {
  const [articleData, setArticleData] = useState();
  const [accueil, setAccueil] = useState();
  const [loading, setLoading] = useState(true);
  const [formations, setFormations] = useState();

  useEffect(() => {
    fetchArticles();
  }, [])

  const fetchArticles = async () => {
    try {
      let response = await BlogService.fetchArticles();
      let articles = await Promise.all(response.data.slice(0, 3).map(async (article) => {
        let articleModel = new ArticleModel();
        articleModel.id = article.id;
        articleModel.title = article.title;
        articleModel.content = article.content;
        articleModel.date = article.date;

        // Fetch image data
        articleModel.images = article.images[0].replace('/api/imagess', '/api/images/display');

        return articleModel; // Return the constructed article model
      }));

      setArticleData(articles); // Set the complete articles array
    } catch (error) {
      console.log("Erreur: " + error);
    } finally {
      try {
        let response = await BlogService.getAccueil();
        console.log(response.data);

        setAccueil(response.data)
      } catch (error) {
        console.log("Erreur: " + error);
      } finally {
        try {
          let response = await TrainingService.fetchTrainings();
          let incendieList = [];
          response.data.trainings.slice(0, 3).map(training => {
            incendieList.push(training);
          });
          setFormations(incendieList);
        } catch (error) {
          console.log("erreur" + error);
        } finally {
          setLoading(false); // Set loading to false after fetching data
        }
      }

    }
  }
  return (AccueilView(articleData, accueil, formations, loading))
}

export default GetAccueilController;